import { Typography } from '@mui/material';
import { useInstanceSelector } from '@client/hooks/redux.hooks';
import { getGenreLabels } from '@client/selectors/entities/categories';
import type { TypographyProps } from '@mui/material';

interface GenreLabelsProps {
  readonly primaryGenre: string;
  readonly secondaryGenre: string;
}

export const GenreLabels: React.FC<GenreLabelsProps & TypographyProps> = ({ primaryGenre, secondaryGenre, ...restProps }) => {
  const labels = useInstanceSelector(getGenreLabels, [primaryGenre, secondaryGenre]);

  return (
    <Typography
      variant="caption"
      color="disabled"
      {...restProps}
    >
      {labels}
    </Typography>
  );
};
